module.exports = __webpack_public_path__ + "img/11.4-gallery.29f478a9.jpg";